import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

// actions
import {
  sofologistLoginSuccessful,
  sofologistLoginFailed,
} from "../../actions/sofologist";

// components
import MySofologyLogo from "../../layout/graphics/MySofologyLogo";
import OverlayLoader from "../../parts/OverlayLoader";

// services
import { getPointOfSales } from "../../services/storeService";

import { config } from "../../config";

class _LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      stores: [],
      selectedPOS: "",
      isTelStore: false,
    };
    this.updateField = this.updateField.bind(this);
    this.handleResponse = this.handleResponse.bind(this);
    this.loadStores = this.loadStores.bind(this);
    this.handlePOSChange = this.handlePOSChange.bind(this);
    this.loadStores();
  }

  loadStores() {
    return getPointOfSales()
      .then((stores) => this.setState({ stores }))
      .catch(() =>
        this.props.sofologistLoginFailed(
          "Failed to get stores list please try again or contact IT if the problem persists."
        )
      )
      .finally(() => this.setState({ loading: false }));
  }

  updateField(field) {
    const obj = {};
    obj[field] = this[field].value;
    this.setState(obj);
  }

  handleResponse(callback, response) {
    callback(response, this.state.selectedPOS, this.state.isTelStore)
      .then(() => this.setState({ loading: false }))
      .catch(() => this.setState({ loading: false }));
  }

  handlePOSChange(e) {
    this.setState({ selectedPOS: e.target.value });
    this.setState({ isTelStore: this.isTelStore(e.target.value) })
  }

  isTelStore(outlet) {
    var currentPos = this.state.stores.find(o => o.outlet.toUpperCase() === outlet.toUpperCase());
    return currentPos ? currentPos.telStore : false;
  }

  handleLoginClick = () => {
    const {
      sofologistLoginSuccessful,
      sofologistLoginFailed,
    } = this.props;

    let client = window.google.accounts.oauth2.initTokenClient({
      client_id: config.APP_INFO.CLIENT_ID,
      scope: 'https://www.googleapis.com/auth/admin.directory.group.readonly \
              https://www.googleapis.com/auth/userinfo.email',
      callback: (response) => this.handleResponse(sofologistLoginSuccessful, response),
      error_callback: (error) => this.handleResponse(sofologistLoginFailed, error),
    });

    this.setState({ loading: true }, () => {
      client.requestAccessToken();
    });
  }

  render() {
    const {
      sofologistLoginSuccessful,
      sofologistLoginFailed,
      errors,
    } = this.props;

    return (
      <div className="login-page">
        <h1>
          <div className="logo">
            <MySofologyLogo textColor="black" />
            <div className="u-padding-bottom-micro">Admin</div>
          </div>
        </h1>

        <form
          className="login-form"
          method="post"
          onSubmit={(e) => e.preventDefault()}
          style={{ position: "relative" }}
        >
          <OverlayLoader
            active={this.state.loading}
            background={"rgba(247, 247, 247, .8)"}
          />
           
          <button className="google-login-button"
            disabled={this.state.loading || !this.state.selectedPOS}
            onClick={this.handleLoginClick}
          >
            Login
          </button>

          <div className="u-padding-top">
            <select
              className="form__group__inputFields u-w-100"
              onChange={this.handlePOSChange}
              value={this.state.selectedPOS}
            >
              <option value={""}>Select Your Location</option>
              {this.state.stores
                .sort((a, b) =>
                  a.outlet.toUpperCase().localeCompare(b.outlet.toUpperCase())
                )
                .map((store, index) => (
                  <option
                    key={`location${index}`}
                    value={store.outlet.toUpperCase()}
                  >
                    {store.outlet.toUpperCase()}
                  </option>
                ))}
            </select>
          </div>
        </form>

        <div className="errors">{this.state.loading ? null : errors}</div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({ errors: state.sofologist.errors });

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      sofologistLoginSuccessful,
      sofologistLoginFailed,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(_LoginPage);



// WEBPACK FOOTER //
// ./src/pages/AdminPage/SofologistLogin.js